var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"app"}},[_c('main',{staticClass:"main-content container py-3"},[_c('transition',{attrs:{"name":"page"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }